import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { therapyPlanningAction } from '../../actions/constant';
import therapyPlanningService from '../../../services/apiServices/therapyPlanning/therapyPlanning';

const {
  CHECK_THERAPY_PLANNING_PLAN_MINUTES_REQUEST,
  CHECK_THERAPY_PLANNING_PLAN_MINUTES_SUCCESS,
  CHECK_THERAPY_PLANNING_PLAN_MINUTES_FAILURE,
  CHECK_THERAPY_PLANNING_PLAN_MINUTES_LOADING,
} = therapyPlanningAction;

function* checkTherapyPlanningPlanMinutes(payload: any): SagaReturnType<any> {
  yield put({ type: CHECK_THERAPY_PLANNING_PLAN_MINUTES_LOADING });
  try {
    const response = yield call(
      therapyPlanningService.checkTherapyPlanningPatient_v2,
      payload?.payload
    );
    if (response?.status === 200) {
      yield put({ type: CHECK_THERAPY_PLANNING_PLAN_MINUTES_SUCCESS, payload: response?.data });
    } else {
      throw response?.data;
    }
  } catch (error) {
    yield put({ type: CHECK_THERAPY_PLANNING_PLAN_MINUTES_FAILURE, payload: error });
  }
}

function* checkTherapyPlanningPlanMinutesSaga() {
  yield takeEvery(CHECK_THERAPY_PLANNING_PLAN_MINUTES_REQUEST, checkTherapyPlanningPlanMinutes);
}

export default checkTherapyPlanningPlanMinutesSaga;
